import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8735f970"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "registration-form" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Register", -1))
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 0,
  class: "p-pb-2"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title-input" }, " Creator Name (required) ", -1))
const _hoisted_7 = { class: "error-msg" }
const _hoisted_8 = {
  key: 1,
  class: "p-pb-2"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title-input p-pb-2" }, " Brand Name (required) ", -1))
const _hoisted_10 = { class: "error-msg" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "title-input p-text-center" }, "Sign up with your social media", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "title-input p-text-center" }, "or sign up with email", -1))
const _hoisted_13 = { key: 2 }
const _hoisted_14 = { class: "error-msg" }
const _hoisted_15 = { class: "p-mt-2" }
const _hoisted_16 = { class: "link-login p-mt-6" }
const _hoisted_17 = { class: "p-d-flex p-justify-around positioning" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "© 2022 Gameinfluencer GmbH |", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_user_type_toggle = _resolveComponent("user-type-toggle")!
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_social_connect = _resolveComponent("social-connect")!
  const _component_email_connect = _resolveComponent("email-connect")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.registrationSteep === 1 && !_ctx.sendVerificationEmail)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_user_type_toggle, {
            "is-creator": _ctx.userIsCreator,
            "onUpdate:isCreator": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userIsCreator) = $event)),
            disabled: !!_ctx.connecting
          }, null, 8, ["is-creator", "disabled"]),
          _createVNode(_component_Button, {
            class: "red-button p-mt-5 w-100 btn",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.registrationSteep += 1))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Register")
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (_ctx.registrationSteep === 2 && !_ctx.sendVerificationEmail)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_ctx.userIsCreator === 'creator')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _hoisted_6,
                _createVNode(_component_InputText, {
                  class: "input-write",
                  type: "text",
                  modelValue: _ctx.creatorName,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.creatorName) = $event))
                }, null, 8, ["modelValue"]),
                _withDirectives(_createElementVNode("span", _hoisted_7, "The use of the \"@\" symbol is prohibited.", 512), [
                  [_vShow, _ctx.nameError]
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.userIsCreator !== 'creator')
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _hoisted_9,
                _createVNode(_component_InputText, {
                  class: "input-write",
                  type: "text",
                  modelValue: _ctx.brandName,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.brandName) = $event))
                }, null, 8, ["modelValue"]),
                _withDirectives(_createElementVNode("span", _hoisted_10, "The use of the \"@\" symbol is prohibited.", 512), [
                  [_vShow, _ctx.nameError]
                ])
              ]))
            : _createCommentVNode("", true),
          _hoisted_11,
          _createVNode(_component_social_connect, {
            action: "register",
            "name-error": _ctx.nameError,
            username: _ctx.username,
            connecting: _ctx.connecting,
            "onUpdate:connecting": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.connecting) = $event)),
            items: _ctx.availableSocialConnections,
            userType: _ctx.userType,
            onConnect: _ctx.handleUserConnect
          }, null, 8, ["name-error", "username", "connecting", "items", "userType", "onConnect"]),
          _hoisted_12,
          _createVNode(_component_email_connect, {
            register: true,
            onRegister: _ctx.registrationViaEmail
          }, null, 8, ["onRegister"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.sendVerificationEmail)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("p", null, "We have sent a code to your mail " + _toDisplayString(_ctx.emailUser) + ", to verify your mail, please enter it here:", 1),
          _createVNode(_component_InputText, {
            placeholder: "Enter the confirmation code",
            class: "input-write",
            type: "text",
            modelValue: _ctx.verificationCode,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.verificationCode) = $event))
          }, null, 8, ["modelValue"]),
          _withDirectives(_createElementVNode("span", _hoisted_14, "The verification code is invalid", 512), [
            [_vShow, _ctx.verificationCodeError]
          ]),
          _createElementVNode("p", _hoisted_15, [
            _createTextVNode(" Didn't receive the "),
            _createVNode(_component_router_link, {
              style: {"color":"red","font-weight":"bold","text-decoration":"underline"},
              to: "",
              onClick: _ctx.sendVerificationCode
            }, {
              default: _withCtx(() => [
                _createTextVNode(" code? Send again. ")
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_Button, {
              class: "red-button p-mt-5 w-100 btn",
              onClick: _ctx.registryWithVode
            }, {
              default: _withCtx(() => [
                _createTextVNode("Register")
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_16, [
      _createTextVNode(" Already have a registration? "),
      _createVNode(_component_router_link, {
        style: {"color":"red","font-weight":"bold","text-decoration":"underline"},
        to: { name: 'login' }
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Sign in ")
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _createElementVNode("div", {
          class: "footer",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$router.push({ name: 'terms-of-use' })))
        }, " TERMS OF USE |"),
        _createElementVNode("div", {
          class: "footer",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$router.push({ name: 'legacy-of-notice' })))
        }, "LEGAL NOTICE |"),
        _createElementVNode("div", {
          class: "footer",
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$router.push({name: 'privace-policy'})))
        }, " PRIVACY POLICY |")
      ])
    ])
  ]))
}